import React from "react";
import Modules from './module.component';

interface Props {
  propertyType: any;
  module1: any;
  module2: any;
  module3: any;
  module4: any;
  modulesCompleted: boolean;
  showAlternative: string;
  setModule1: (value: any) => void;
  setModule2: (value: any) => void;
  setModule3: (value: any) => void;
  setModule4: (value: any) => void;
  setShowAlternative: (value: any) => void;
  setModulesCompleted: (value: any) => void;

  activeGroup: number;
  modulesList: any;
  isAlternative: boolean;
  availableTypologies: any;
  setActiveGroup: (number: any) => void;
  setModulesList: (value: any) => void;
  setIsAlternative: (boolean: any) => void;
  setAvailableTypologies: (value: any) => void;
}

const BottombarModules: React.FC<Props> = ({ propertyType, module1, module2, module3, module4, modulesCompleted, showAlternative, setModule1, setModule2, setModule3, setModule4, setModulesCompleted, setShowAlternative,
activeGroup, modulesList, isAlternative, availableTypologies, setActiveGroup, setModulesList, setIsAlternative, setAvailableTypologies }) => {
  

  const states: any = {
    module1: {
      state: module1,
      setter: setModule1,
    },
    module2: {
      state: module2,
      setter: setModule2,
    },
    module3: {
      state: module3,
      setter: setModule3,
    },
    module4: {
      state: module4,
      setter: setModule4,
    }
  };

  return (
    <div className="bottombar-menu-modules">
      <div className="bottombar-modules-content">
        <div className='bottombar-modules-container-title'>Personaliza</div>
        <div className='bottombar-modules'>
        {
          modulesList.map( (local_modules: any, index: number) => 
            <Modules key={local_modules.index} module1={module1} module2={module2} module3={module3} module4={module4} modules={local_modules} totalModules={modulesList.length} availableTypologies={availableTypologies}
                    activeGroup={activeGroup} setActiveGroup={setActiveGroup} currentModule={states[local_modules.category]['state']} setCurrentModule={states[local_modules.category]['setter']}/>
          )
        }
        </div>
        <div className={`bottombar-module-alternatives ${isAlternative ? '':'hide'}`}>
          <div className={`bottombar-module-alternative ${showAlternative === "Sofá" ? 'selected':''}`} onClick={()=>setShowAlternative("Sofá")}>
            <div className={`bottombar-module-alternative-text ${showAlternative === "Sofá" ? 'selected':''}`}>Ver Sofá</div>
          </div>
          <div className={`bottombar-module-alternative ${showAlternative === "Murphy" ? 'selected':''}`} onClick={()=>setShowAlternative("Murphy")}>
            <div className={`bottombar-module-alternative-text ${showAlternative === "Murphy" ? 'selected':''}`}>Ver Murphy</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottombarModules;